import moment from 'moment';
import ExportJsonExcel from 'js-export-excel';

class GenerateExcelReportServices {
    exportExcel(data, invoice) {
        let option = {};  // La opción representa el archivo de Excel
        let invoiceDetails = this.invoiceDetails(data);
        option.fileName = 'EXC_' + data[0].consecutivo + data[0].num_documento;  // Nombre del archivo Excel
        console.log("DOCEXCEL", data)
        option.datas = [
            {
                sheetData: invoiceDetails.data,  // Fuente de datos en archivo Excel
                sheetName: option.fileName,  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
    }

    invoiceDetails(details) {
        let dataTable = [];  // Contenido de datos en archivo Excel
        let titlesExcel = this.generateTitlesInvoiceExcel();//Titulos de la Factura
        dataTable.push(titlesExcel);
        
        for (let i = 0; i < details.length; i++) {
            let detailExcel = this.generateInvoiceDetailBoxs(details[i]);//Detalles de la FActura
            dataTable.push(detailExcel);
        }

        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generateTitlesInvoiceExcel() {
        let Titulos = {
            '1': 'F. Factura',
            '2': 'RAD',
            '3': 'ID_Paciente',
            '4': 'Nombre_del_Paciente',
            '5': 'Nombre_del_Procedimiento',
            '6': 'Factura',
            '7': 'Recibo',
            '8': 'Valor_Total',
            '9': 'Recuperacion',
            '10': 'Entidad'
        }
        return Titulos;
    }

    generateInvoiceDetailBoxs(details) {
        let Casillas = {
            '1':    details.fecha != null && details.fecha != undefined ? details.fecha : "",
            '2':    details.num_radicado != null && details.num_radicado != undefined ? details.num_radicado : "",
            '3':    details.num_documento != null && details.num_documento != undefined ? details.num_documento : "",
            '4':    details.nombre_paciente != null && details.nombre_paciente != undefined ? details.nombre_paciente : "",
            '5':    details.l_procedimiento != null && details.l_procedimiento != undefined ? details.l_procedimiento : "",
            '6':    details.consecutivo != null && details.consecutivo != undefined ? details.consecutivo : "",
            '7':    details.id_recibo != null && details.id_recibo != undefined ? details.id_recibo : "",
            '8':    details.valor_servicio_item != null && details.valor_servicio_item != undefined ? details.valor_servicio_item : "",
            '9':    details.valor_copago_item != null && details.valor_copago_item != undefined ? details.valor_copago_item : "",
            '10':   details.valor_neto_item != null && details.valor_neto_item != undefined ? details.valor_neto_item : ""
        }
        return Casillas;
    }

}
export default new GenerateExcelReportServices();